import { AxiosError } from 'axios';

export const getErrorStatus = (error: Error | AxiosError | null): number | undefined => {
    if (!error) return undefined;

    if ('status' in error) {
        if (typeof error.status === 'number') {
            return error.status;
        }
        if (typeof error.status === 'string') {
            const parsed = Number(error.status);
            if (!isNaN(parsed) && isFinite(parsed)) {
                return parsed;
            }
        }
    }

    if ('isAxiosError' in error && (error as AxiosError).response?.status) {
        return (error as AxiosError).response?.status;
    }

    return undefined;
};
